/// <reference path="reference.ts" />

module project {

	var application = new Application();
	application.run();
}
